import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-x', 'IconLetterX', [["path",{"d":"M7 4l10 16","key":"svg-0"}],["path",{"d":"M17 4l-10 16","key":"svg-1"}]]);